var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 11,
    viewBox: "0 0 160 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA0\xD0\xB5\xD1\x81\xD1\x83\xD1\x80\xD1\x81 1 1",
    clipPath: "url(#clip0_704_3514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA1\xD0\xBB\xD0\xBE\xD0\xB9 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA1\xD0\xBB\xD0\xBE\xD0\xB9 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.40993 8.55713C3.75787 8.55713 2.62395 7.62001 2.62395 5.49742C2.62395 3.37483 3.7485 2.47051 6.40993 2.47051C8.59343 2.47051 9.85855 3.11244 10.1069 4.75709H12.773C12.5106 1.81452 10.4724 0.272949 6.40993 0.272949C1.92111 0.272949 0 2.11908 0 5.49742C0 8.87575 1.92111 10.7547 6.40993 10.7547C10.4724 10.7547 12.5012 9.19906 12.773 6.24243H10.1069C9.83981 7.90114 8.57938 8.55713 6.40993 8.55713Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.7996 0.418213H17.2573L12 10.6094H14.8863L15.9781 8.44H22.0694L23.1612 10.6094H26.0616L20.7996 0.418213ZM16.9527 6.50952L19.0378 2.37212L21.0854 6.49078L16.9527 6.50952Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.2141 0.418213V8.07921L30.2513 0.418213H26.709V10.6094H29.3282V2.96719L36.2677 10.6094H39.8287V0.418213H37.2141Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M51.5145 0.418213V8.07921L44.5517 0.418213H41V10.6094H43.6193V2.96719L50.568 10.6094H54.1338V0.418213H51.5145Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M80.6584 5.07582C81.162 4.53362 81.4474 3.82435 81.4597 3.08443C81.4597 1.58503 80.7427 0.408936 78.4281 0.408936H69.4551V10.6095H78.7795C81.0942 10.6095 82.0969 9.35848 82.0969 7.63885C82.1087 7.12196 81.9814 6.6114 81.7283 6.16053C81.4753 5.70966 81.1058 5.33504 80.6584 5.07582ZM72.079 2.3113H77.4816C78.1938 2.3113 78.8357 2.3113 78.8357 3.35619C78.8357 4.40109 78.1938 4.41983 77.4956 4.41983H72.079V2.3113ZM78.1375 8.58535H72.079V6.42996H78.1375C78.8357 6.42996 79.4776 6.42996 79.4776 7.50766C79.4776 8.58535 78.8357 8.58535 78.1375 8.58535V8.58535Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M93.7359 2.49863V0.418213H82.959V10.6094H93.7359V8.52903H85.5782V6.46267H93.7359V4.56499H85.5782V2.49863H93.7359Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M94.4492 0.418213V2.61577H99.4019V10.6094H102.021V2.61577H106.974V0.418213H94.4492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M119.745 4.15744C119.745 1.88959 118.156 0.408936 115.842 0.408936H107.834V10.6095H110.453V7.88719H114.67L116.315 10.6095H119.403L117.529 7.58263C118.212 7.31804 118.794 6.84438 119.192 6.22928C119.59 5.61418 119.783 4.88906 119.745 4.15744V4.15744ZM115.115 5.68963H110.43V2.61586H115.115C115.903 2.61586 117.14 2.61586 117.14 4.15744C117.14 5.69901 115.903 5.68963 115.115 5.68963V5.68963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M130.887 0.418213V5.49743C130.887 6.90312 130.494 8.55714 127.101 8.55714C123.709 8.55714 123.315 6.92654 123.315 5.49743V0.418213H120.691V5.49743C120.691 9.05382 122.617 10.7547 127.101 10.7547C131.585 10.7547 133.507 9.03976 133.507 5.49743V0.418213H130.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M140.966 4.48993C137.995 4.31187 137.382 4.16662 137.382 3.37943C137.382 2.59225 137.995 2.37671 140.573 2.37671C143.295 2.37671 144.419 2.65316 144.419 3.7824H147.039C147.039 1.26622 144.696 0.305664 140.863 0.305664C137.03 0.305664 134.772 1.01788 134.772 3.25761C134.772 5.49733 136.534 6.24703 140.976 6.44852C144.255 6.60783 144.865 6.75308 144.865 7.60118C144.865 8.44928 144.035 8.70699 141.28 8.70699C137.963 8.70699 137.086 8.21031 137.086 7.13262H134.477C134.477 10.0752 136.965 10.7874 141.144 10.7874C144.916 10.7874 147.493 10.2345 147.493 7.50747C147.474 4.90226 144.986 4.68204 140.966 4.48993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M147.475 0.418213V2.61577H152.427V10.6094H155.051V2.61577H159.999V0.418213H147.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M61.584 9.28809C61.6361 9.16033 61.7004 9.03793 61.7761 8.92261L61.748 10.6094H60.6328C61.0701 10.2694 61.4003 9.81068 61.584 9.28809Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M60.7726 8.27143C61.1206 8.43078 61.4573 8.61396 61.78 8.81965V8.81965C61.6348 8.78685 61.1803 8.66502 61.0116 8.59942C59.1655 7.84035 57.0148 8.2808 55.8574 8.59942L57.2912 5.81616C58.2251 6.91609 59.423 7.7609 60.7726 8.27143V8.27143Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M61.012 9.08673C61.2638 8.99769 61.5203 8.92261 61.7804 8.86182V8.86182C61.6574 8.94647 61.5254 9.01719 61.3868 9.07267C60.6318 9.34952 60.0026 9.8905 59.6157 10.5955H54.8223L55.6282 9.02581C56.6965 9.38661 58.8566 10.0004 61.012 9.08673Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M61.4565 7.58259C61.5904 7.93346 61.6985 8.29365 61.7799 8.66028V8.77274C61.6627 8.57125 61.3441 8.02772 61.2504 7.79813C60.6567 6.23176 59.6296 4.86664 58.2891 3.8622L60.0555 0.437012H61.2176C60.6834 2.38155 60.1914 5.00081 61.4565 7.58259Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M63.0257 10.6096H61.9012L61.873 8.90869C61.9527 9.02814 62.0202 9.15529 62.0745 9.28823C62.2615 9.80913 62.5911 10.267 63.0257 10.6096V10.6096Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M62.4119 7.79813C62.242 8.13735 62.0543 8.46737 61.8496 8.78679V8.65091C61.9239 8.28553 62.0322 7.92787 62.1729 7.58259C63.4802 5.23978 62.9601 2.47526 62.4072 0.437012H63.5692L65.3451 3.86689C64.0169 4.87518 63.0002 6.23781 62.4119 7.79813V7.79813Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M62.8855 8.27129C64.2382 7.76833 65.4398 6.928 66.3763 5.83008L67.8148 8.60865C66.6434 8.29003 64.4974 7.85895 62.6606 8.60865C62.4873 8.67894 62.014 8.80076 61.8828 8.83356C62.2042 8.62405 62.5392 8.43621 62.8855 8.27129V8.27129Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M68.8499 10.6095H64.0472C63.6589 9.90554 63.0302 9.36496 62.276 9.08663C62.1351 9.02782 62.0002 8.95565 61.873 8.87109V8.87109C62.1364 8.93323 62.396 9.00988 62.6509 9.10069C64.8062 10.0378 66.971 9.40057 68.0393 9.05383L68.8499 10.6095Z",
    fill: "#4FA778"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_704_3514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 10.4817,
    fill: "white",
    transform: "translate(0 0.272949)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo-2.745cf27c665a4a042baa13905a6c0d58.svg";
export { ForwardRef as ReactComponent };